<template>
  <div>
    <social-profile-form />
  </div>
</template>

<script>
import SocialProfileForm from './social-profiles-form'
export default {
  components: { SocialProfileForm }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/profile/profiles/add-profile.vue